import { render, staticRenderFns } from "./ModernDatePickerComposition.vue?vue&type=template&id=79c2ea64&scoped=true&"
import script from "./ModernDatePickerComposition.vue?vue&type=script&lang=js&"
export * from "./ModernDatePickerComposition.vue?vue&type=script&lang=js&"
import style0 from "./ModernDatePickerComposition.vue?vue&type=style&index=0&id=79c2ea64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c2ea64",
  null
  
)

export default component.exports